// extracted by mini-css-extract-plugin
module.exports = {"img":"history_img__1hGgl"};